export default {"src":"/_next/static/media/pharmexcil.96830f0f.svg","height":63,"width":269};